import Hero from '../components/Hero';
import ClientStats from '../components/ClientStats';
import About from '../components/About';
import Services from '../components/Services';
import WhyUs from '../components/WhyUs';
import Process from '../components/Process';
import Reviews from '../components/Reviews';
import ContactCTA from '../components/ContactCTA';

export default function Home() {
  return (
    <>
      <Hero />
      <ClientStats />
      <About />
      <Services />
      <WhyUs />
      <Process />
      <Reviews />
      <ContactCTA />
    </>
  );
}
